import React from 'react';

import { AspectRatio } from '@/components/ui/aspect-ratio';
import { LanguageIsoCode, type Program } from '@/graphql/graphql';
import { cn } from '@/lib/utils';
import PlaceholderImage from '@public/images/program_placeholder.svg';
import Image from 'next/image';

export default function CoverImage({
    program,
    language,
    className,
    imageUrl,
    alt,
    fallbackTitle = false,
}: {
    program: Program;
    language?: LanguageIsoCode;
    imageUrl?: string;
    className?: string;
    alt?: string;
    fallbackTitle?: boolean;
}) {
    const coverUrl = imageUrl ?? program.coverUrl ?? program?.parent?.coverUrl ?? PlaceholderImage.src;
    const locale = language ? language.toLowerCase() : LanguageIsoCode.En.toLowerCase();
    return (
        <div className="relative">
            <AspectRatio ratio={3 / 4} className={className}>
                <Image
                    src={coverUrl.replace('source.jpg', 'webapp.jpg')}
                    alt={alt ?? ''}
                    fill
                    className={cn('object-cover rounded-lg', program?.coverUrl ? 'border border-gray-400' : null)}
                />
                {fallbackTitle && !(program?.coverUrl ?? program?.parent?.coverUrl) ? (
                    <div className="absolute inset-0 flex items-center justify-center">
                        <p className="line-clamp-3 text-[8cqw] font-bold text-white text-center px-2 pt-[65%]">
                            {program.titles[locale as LanguageIsoCode]}
                        </p>
                    </div>
                ) : null}
            </AspectRatio>
        </div>
    );
}
